export interface Input extends Marko.HTML.Div {}

<style/styles: any>
  .container {
    max-width: var(--wrapper-max-width, 85rem);
  }

  .container[data-width="prose"] {
    --wrapper-max-width: var(--prose-width);
  }

  .container[data-width="medium"] {
    --wrapper-max-width: 75rem;
  }
</style>

<const/{ class: className, style, ...attrs }=input>

<div
  style=[
    "--shadow-color: var(--pink-shadow)",
    {
      ["box-shadow"]: "10px 10px 0px 0px var(--shadow-color)",
    },
    style,
  ]
  data-width="medium"
  class=[
    "border-solid radius2 mi-auto pi-2 relative",
    styles.container,
    className,
  ]
  ...attrs
/>
